import React, { useMemo } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { CollaborationItem, Milestone } from 'types/collaboration'
import userDummayImage from "../../assets/images/users/user-dummy-img.jpg";

const CollaborationListItem: React.FC<{ collaboration: CollaborationItem }> = ({ collaboration }) => {

    const { campaignId, influencerId, milestoneId } = useParams();

    const [searchParams] = useSearchParams();
    const filtersQuery = searchParams.get('filters');


    const getMilestoneName = (milestone: Milestone) => {
        return `${collaboration.milestones_count > 1 ? `#${milestone?.sort_order} ` : ''}${milestone?.gig_type?.name}`
    }

    const {myStep, influencerStep, brandStep } = useMemo(() => {
        const activeSteps = Array.isArray(collaboration?.active_steps) ? collaboration.active_steps : [];
        const myStep = activeSteps.find((step) => step.assignees?.includes('hub'));
        const influencerStep = activeSteps.find((step) => step.assignees?.includes('influencer'));
        const brandStep = activeSteps.find((step) => step.assignees?.includes('agency'));
        return { myStep, influencerStep, brandStep };
    }, [collaboration])


    return (
        <li key={collaboration.campaign.uuid + '-' + collaboration.influencer.uuid} className={(collaboration.campaign.uuid === campaignId && collaboration.influencer.uuid === influencerId) ? "active" : ""}>
            <Link to={{ pathname: (collaboration?.active_milestone?.id || collaboration.milestones?.[0]) ? 
                `/tasks/${collaboration.campaign.uuid}/influencer/${collaboration.influencer.uuid}/milestone/${collaboration.active_milestone?.id ? collaboration.active_milestone.id : (collaboration.milestones?.[0]?.id ?? '')}` 
                : `/tasks/${collaboration.campaign.uuid}/influencer/${collaboration.influencer.uuid}`, search: filtersQuery ? `?filters=${filtersQuery}` : ''  }}>
                <div className="d-flex align-items-center">
                    <div className={`flex-shrink-0 chat-user-img align-self-center me-2 ms-0`}>
                        {collaboration.influencer?.social_account?.profile_picture_url ? (
                            <img src={collaboration.influencer.social_account?.profile_picture_url} className="rounded-circle avatar-xs" alt="" />
                        ) : (
                            <img src={userDummayImage} className="rounded-circle avatar-xs" alt="" />
                        )}
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                        <p className="text-truncate mb-0">{collaboration?.influencer?.name}</p>
                        {
                            influencerStep ? (
                                <span className='text-truncate fs-12 text-warning'>
                                            <span className="fw-bold">Waiting for: </span>
                                            <span>{influencerStep.gig_step.title ?? influencerStep.gig_step.name}</span>
                                        </span>
                            ) : (
                                myStep ? (
                                    <span className='text-truncate fs-12 text-success'>
                                        <span className="fw-bold">Action Needed: </span>
                                        <span>{myStep.gig_step.title ?? myStep.gig_step.name}</span>
                                    </span>
                                ) : (
                                    brandStep ? (
                                        <span className='text-truncate fs-12 text-muted'>
                                            <span className="fw-bold">Waiting for: </span>
                                            <span>{brandStep.gig_step.title ?? brandStep.gig_step.name}</span>
                                        </span>
                                    ) : ''
                                )
                            )
                        }
                        <p className="text-truncate text-muted fs-12 mb-0">{collaboration.campaign?.name}</p>
                    </div>
                </div>
            </Link>
        </li>
    )
}

export default CollaborationListItem